import React from 'react';

import Thumbnail from './Thumbnail';

import classes from './styles.module.scss';

export default function Thumbnails({
  currentImageIndex,
  setCurrentImageIndex,
  images,
}) {
  return (
    <div className={classes.Thumbnails}>
      {images?.map((image, index) => (
        <Thumbnail
          key={image.signedS3Url}
          index={index}
          currentImageIndex={currentImageIndex}
          setCurrentImageIndex={setCurrentImageIndex}
          image={image}
        />
      ))}
    </div>
  );
}
